export default "__VITE_ASSET__bd15734e__"